import { listViewStore, isItemPartOperation } from 'owa-mail-list-store';
import * as lazyTriageActions from 'owa-mail-triage-action';
import { getActionSourceFromCommandingViewMode } from 'owa-command-ribbon';
import { lazyOnSingleSelectionChanged } from 'owa-mail-mark-read-actions';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import { getRootFolderIdForGivenContext } from 'owa-mail-moveto-control/lib/helpers/moveToCommonUtils';
import { getMailboxInfoForFolderId } from 'owa-folders';
import { createNewFolder } from 'owa-mail-movetofolder-view/lib/components/createNewFolderUtil';
import moveToStore from 'owa-mail-moveto-control/lib/store/store';

export const onMoveToFolderClicked = (folderId: string) => {
    const tableViewId = listViewStore.selectedTableViewId;
    const tableView = listViewStore.tableViews.get(tableViewId)!;
    let markAsReadAction = Promise.resolve();

    // Mark as read item if user selected only one item, as reading pane
    // cannot show more than one item at a time if there are multiple items selected.
    if (tableView.selectedRowKeys.size === 1) {
        markAsReadAction = lazyOnSingleSelectionChanged.importAndExecute(
            [...tableView.selectedRowKeys.keys()][0],
            tableView,
            true /* isUserNavigation */
        );
    }

    markAsReadAction.then(() => {
        if (isItemPartOperation()) {
            lazyTriageActions.lazyMoveItemsBasedOnNodeIds.import().then(moveItemsBasedOnNodeIds => {
                moveItemsBasedOnNodeIds(
                    listViewStore.expandedConversationViewState.selectedNodeIds,
                    folderId,
                    tableView.id,
                    getActionSourceFromCommandingViewMode()
                );
            });
        } else {
            lazyTriageActions.lazyMoveMailListRows.importAndExecute(
                [...tableView.selectedRowKeys.keys()],
                folderId,
                tableView.id,
                getActionSourceFromCommandingViewMode()
            );
        }
    });
    lazyResetFocus.importAndExecute();
};

export const onCreateNewFolderClicked = (folderName: string) => {
    const { moveToMailboxType, moveToSharedFolderRootId } = moveToStore;

    // Get appropriate root folder id depending on the current moveToMailboxType.
    // Except 'SharedMailbox', all other mbxs have static rootFolderId. But sharedFolder root Id is stored in local store.
    const rootFolderId =
        moveToMailboxType === 'SharedMailbox'
            ? moveToSharedFolderRootId
            : getRootFolderIdForGivenContext(moveToMailboxType);

    if (rootFolderId === undefined) {
        return;
    }

    const mailboxInfo = getMailboxInfoForFolderId(rootFolderId, false /* routeToAuxIfAuxArchive */);

    createNewFolder(folderName, rootFolderId, mailboxInfo).then(folderId => {
        if (folderId) {
            onMoveToFolderClicked(folderId);
        }
    });

    // Dismiss menu
    lazyResetFocus.importAndExecute();
};

export const onMoveToFocusedOtherInboxClicked = (toViewFilter: FocusedViewFilter) => {
    const tableViewId = listViewStore.selectedTableViewId;
    const tableView = listViewStore.tableViews.get(tableViewId)!;

    lazyTriageActions.lazyMoveMailListRowsToFocusedOrOther.importAndExecute(
        [...tableView.selectedRowKeys.keys()],
        tableView.id,
        toViewFilter,
        getActionSourceFromCommandingViewMode()
    );
    lazyResetFocus.importAndExecute();
};

export const onAlwaysMoveToFocusedOtherInboxClicked = (toViewFilter: FocusedViewFilter) => {
    const tableViewId = listViewStore.selectedTableViewId;
    const tableView = listViewStore.tableViews.get(tableViewId)!;

    lazyTriageActions.lazyAlwaysMoveRowToFocusedOrOther.importAndExecute(
        [...tableView.selectedRowKeys.keys()],
        tableView,
        toViewFilter,
        getActionSourceFromCommandingViewMode()
    );
    lazyResetFocus.importAndExecute();
};
